import { render, staticRenderFns } from "./EscalationMatrixPanel.vue?vue&type=template&id=3a2f6e75"
import script from "./EscalationMatrixPanel.vue?vue&type=script&lang=js"
export * from "./EscalationMatrixPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports